_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupEventDetailCtrl = ($scope ,$translate ,$filter ,flash , $location ,groupEventService , detailData ,$ngConfirm ) ->
  angular.element(document.body).css 'min-width', 0
  pageSize = 4
  $scope.lstScoreCards = []
  $scope.currentPage = 0
  $scope.isLoading = false
  $scope.noResults = true
  $scope.eventDetail = detailData.eventDetail
  $scope.groupDetail = detailData.groupDetail

  $scope.loadMore = ->
    $scope.isLoading = true
    $scope.currentPage++
    params =
      id : $scope.eventDetail.id
      page : $scope.currentPage
      page_size : pageSize
      submitted : true
    groupEventService.listScoreCardByEvent(params)
      .then (data) ->
        $scope.lstScoreCards = _.union($scope.lstScoreCards , data.score_cards)
        $scope.totalPages = data.total_pages
        $scope.noResults = $scope.lstScoreCards.length is 0
      .finally ->
        $scope.isLoading = false

  $scope.hasMore = ->
    $scope.noResults == false && $scope.currentPage isnt $scope.totalPages

  refreshListData = ->
    $scope.lstScoreCards = []
    $scope.currentPage = 0
    $scope.isLoading = false
    $scope.noResults = true
    $scope.loadMore()

  $scope.displayPeriod = (startTime, endTime) ->
    reText = ""
    if !startTime && !endTime
      return reText
    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME')
    reText += ": "
    reText += $scope.displayDateByLang(startTime)
    reText += "~"
    reText += $scope.displayDateByLang(endTime)
    reText

  $scope.displayDateByLang = (time) ->
    if !time
      return ""
    d = moment(time)
    formatText = 'YYYY-MM-DD(ddd)'
    if /^ja/i.test $translate.preferredLanguage()
      formatText = 'LL(ddd)'
      moment.locale('ja')
    d.format(formatText)

  $scope.displayParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  $scope.displayNoParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  $scope.gotoSubmit = ->
    $location.path('/group-event/'+ $scope.eventDetail.id + '/scorecards')

  $scope.gotoEventRank = ->
    $location.path('/group-event/'+ $scope.eventDetail.id + '/ranking')

  $scope.gotoTimelineTab = ->
    url = "/groups/"+ $scope.groupDetail.id + "#timeline"
    $location.url(url)

  $scope.gotoEventTab = ->
    url = "/groups/"+ $scope.groupDetail.id + "#event"
    $location.url(url)

  $scope.gotoRankTab = ->
    url = "/groups/"+ $scope.groupDetail.id + "#rank"
    $location.url(url)

  $scope.$watch('lstScoreCards' , () ->
    if $scope.currentPage <= 1
      return
    $("html, body").animate({ scrollTop:$(document).height()}, "slow")
  , false)

  $scope.removeScoreCard = (id , index) ->
    if !id || id == ''
      return
    mess = $filter('translate')('_GROUP_EVENT.CONFIRM_MESS')
    deleteFunc = ->
      params =
        group_event_id : $scope.eventDetail.id
        score_card_id : id
      groupEventService.unSubmitScoreCard(params)
        .then (resp) ->
          refreshListData()
        .catch (resp) ->
          flash.error $filter('translate')('API_ERROR')
    config =
      title: ''
      content: mess
      buttons:
        Cancel:
          text: $filter('translate')('_GROUP_EVENT.CANCEL')
        OkButton:
          text: 'OK'
          action: deleteFunc

    $ngConfirm(config)

  $scope.loadMore()

GroupEventDetailCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  'flash'
  '$location'
  'groupEventService'
  'detailData'
  '$ngConfirm'
]

module.exports = GroupEventDetailCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-detail-controller.coffee